export enum TYPE_IROPS {
    CANCELED = 1,
    DELAYED = 2,
    STBFULLIST = 3,
    Onboarding = 4,
    USPERSONINFO
}

export enum IROPS_STATUS {
    SCHEDULED = 'Scheduled',
    DELAYED = 'Delayed',
    EARLY = 'Early',
    CANCELLED = 'Cancelled',
    Onboarding ='onboarding',
    ON_TIME = 'on_time',
    USED = 'USED',
}

export enum IROPS_FLIGHT_EXCHANGE_TYPE {
  ITINERARY = 'itinerary',
  OUTBOUND = 'outbound',
  INBOUND = 'inbound',
}